import { useEffect, useState } from 'react';
import { Image, Form, Dropdown, Menu, Typography, Input, Space } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import styles from './index.module.less';
import { logout, generateLicense } from 'features/login/redux/slice';
import { useDispatch } from 'react-redux';
import { getLoggedInUser } from 'utilities/helpers';
import CustomModal from '@/common/CustomModal';
import FormItem from '@/common/FormItem';
import nucleausLogo from '../../images/Graviti_Logo_1.svg';
import gravitiLogo from '../../images/logo.svg';
import CustomButton from '@/common/CustomButton';
import { WarningOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer';
const { Text } = Typography;
const { TextArea } = Input;
const UserMenu = ({ loading }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const signOutClickHandler = () => {
    dispatch(logout());
  };

  const user = getLoggedInUser();

  const [ismodal, setIsmodal] = useState(false);
  const [isLicensemodal, setIsLicensemodal] = useState(false);

  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     console.log(user);
  //   }, 10000000000000);

  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, []);

  const [state, setState] = useState('Active');
  const [count1, setCount1] = useState(0);
  const [remaining, setRemaining] = useState(0);

  const onIdle = () => {
    setState('Idle');
  };

  const onActive = () => {
    setState('Active');
  };

  const onAction = () => {
    setCount1(count1 + 1);
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    onAction,
    timeout: 10 * 60 * 1000,
    throttle: 500
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const timeRemaining = Math.ceil(getRemainingTime() / 1000);
      setRemaining(timeRemaining);
    }, 500);

    return () => clearInterval(interval);
  }, [getRemainingTime]);

  // Separate effect to handle logout
  useEffect(() => {
    if (remaining === 0 && state === 'Idle') {
      dispatch(logout());
    }
  }, [remaining, state, dispatch]);

  const onFinish = (values) => {
    dispatch(generateLicense(values)).then((res) => {
      if (res?.payload?.success) {
        setIsLicensemodal(false);
      } else {
        setIsLicensemodal(false);
      }
    });
  };
  // const handleAutoLogout = () => {
  //   if (remaining === 0 && state === 'Idle') {
  //     dispatch(logout());
  //   }
  // };
  // console.log(remaining);
  const menu = (
    <Menu style={{ width: '130px' }}>
      <Menu.Item key="1">
        <span>
          User ID: <b>{user?.user?.employee}</b>
        </span>
      </Menu.Item>
      <Menu.Item key="2">
        <span>
          User Level: <b>{user?.user?.level}</b>
        </span>
      </Menu.Item>
      {user?.user?.role === 'admin' ? (
        <>
          <Menu.Item key="3" onClick={() => setIsmodal(true)}>
            <span>About Nucleus</span>
          </Menu.Item>
          {!user?.user?.license?.is_active ? (
            <Menu.Item key="4" onClick={() => setIsLicensemodal(true)}>
              <span>Activate License</span>
            </Menu.Item>
          ) : (
            ''
          )}
        </>
      ) : (
        ''
      )}
      <Menu.Item
        onClick={() => signOutClickHandler()}
        key="logout"
        icon={<LogoutOutlined />}
      >
        <Text>Logout</Text>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown className={`${styles.icon_color}`} overlay={menu}>
        <div className={`${styles.gr_logo_header}`}>
          <img
            // className={`${styles.gr_logo_header}`}
            className={styles.logosvg}
            alt="Graviti logo"
            src={gravitiLogo}
          />
          {/* <div> */}
          <div>
            <p>
              {/* <Avatar className={styles.user_menu_avatar}> */}
              {user?.user
                ? user?.user?.fullname.charAt(0).toUpperCase() +
                  user?.user?.fullname.charAt(
                    user?.user?.fullname.indexOf(' ') + 1
                  )
                : ''}
              {/* </Avatar> */}
              {/* <CaretDownOutlined /> */}
            </p>
          </div>
          {/* </div> */}
        </div>
        {/* <div className={`df-jb-ac ${styles.user_menu_container}`}>
          <Image
            className={`${styles.gr_logo_header}`}
            alt="Graviti logo"
            src={gravitiLogo}
            preview={false}
          />

          <Avatar className={styles.user_menu_avatar}>
            {user?.user ? user?.user?.fullname.charAt(0).toUpperCase() : ''}
          </Avatar>
          <CaretDownOutlined />
        </div> */}
      </Dropdown>
      {ismodal ? (
        <CustomModal
          // title="Release Notes"
          visible={ismodal}
          width="30%"
          footer={null}
          className={styles.customModal}
          closable={false}
        >
          <FormItem className="text-center">
            <Image
              className={`${styles.logo_header}`}
              alt="Graviti logo"
              src={nucleausLogo}
              preview={false}
            />
          </FormItem>
          <FormItem className="text-center" style={{ color: 'black' }}>
            <div>Application: Nucleus Manufacturing Automation Solution</div>

            <div>Licensed to: Graviti Pharmaceuticals Private Limited</div>
            <div>Owned by: Lexys Technologies</div>
            <div>Release: 3.1 (Latest)</div>
            <br />
            <div>
              <Link
                to="/Releasenotes.pdf"
                target="_blank"
                download="Release Notes - Nucleus 3.1.pdf"
                style={{ fontSize: '17px', color: '#e80e94' }}
                onClick={() => setIsmodal(false)}
              >
                See Release Notes
              </Link>
            </div>
          </FormItem>
          <FormItem className="text-center">
            <p style={{ fontSize: '10px' }}>
              <WarningOutlined style={{ color: '#ca6363' }} />{' '}
              <span style={{ color: 'grey' }}>
                Warning: This computer program is protected by copyright law and
                international treaties. Unauthorized reproduction or
                distribution of this program, or any portion of it, may result
                in severe civil and criminal penalties, and will be prosecuted
                to the maximum extent possible under the law.
              </span>
            </p>
            <CustomButton
              className={styles.inwardButton}
              onClick={() => setIsmodal(false)}
              type="primary"
              size="small"
            >
              Close
            </CustomButton>
            <br />
            <br />
          </FormItem>
          {/* <FormItem className="text-center"> */}

          {/* </FormItem> */}
        </CustomModal>
      ) : (
        ''
      )}
      {isLicensemodal ? (
        <CustomModal
          // title="Release Notes"
          visible={isLicensemodal}
          width="40%"
          footer={null}
          className={styles.customModal}
          closable={false}
        >
          <Form
            form={form}
            layout="vertical"
            className={`ant-form ant-form-vertical mt-4 ${styles.form_width}`}
            onFinish={onFinish}
          >
            {/* <FormItem className="text-center">
              <Image
                className={`${styles.logo_header}`}
                alt="Graviti logo"
                src={nucleausLogo}
                preview={false}
              />
            </FormItem> */}
            <FormItem
              className="text-center"
              label="License Key"
              name="licenseKey"
              rules={[
                {
                  required: true,
                  message: 'Please Enter your license key'
                }
              ]}
            >
              <TextArea
                rows={6}
                placeholder="Enter license key here"
                className={styles.customLable}
              />
            </FormItem>
            <FormItem className="text-center">
              <Space>
                <CustomButton
                  className={styles.inwardButton}
                  htmlType="submit"
                  loading={loading}
                  type="primary"
                  // size="small"
                >
                  Validate
                </CustomButton>
                <CustomButton
                  className={styles.inwardButton}
                  onClick={() => setIsLicensemodal(false)}
                  type="primary"
                  // size="small"
                  ghost
                >
                  Close
                </CustomButton>
              </Space>
              <br />
              <br />
            </FormItem>
          </Form>
          {/* <FormItem className="text-center"> */}

          {/* </FormItem> */}
        </CustomModal>
      ) : (
        ''
      )}
    </>
  );
};

export default UserMenu;
